var map = {
	"./BOU/non_inventory.png": "32dc",
	"./DRU/non_inventory.png": "f1d8",
	"./FNB/non_inventory.png": "2d80",
	"./HIM/non_inventory.png": "53fa",
	"./OTH/non_inventory.png": "ad59",
	"./SUP/non_inventory.png": "6bf4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c6c";